import style from "./RangeSlider.module.css"
import {useEffect} from "react";

function RangeSlider(props) {

    useEffect(() => {
        if(document.getElementById(props.id)){
            document.getElementById(props.id).oninput = function() {
                let value = (this.value-this.min)/(this.max-this.min)*100
                this.style.background = 'linear-gradient(to right, lightblue 0%, lightblue ' + value + '%, #E8E8E8 ' + value + '%, #E8E8E8 100%)'
            };
        }
    },[props.value])

    return (
        <div className={"row"} style={{alignItems:"center"}}>
            <div style={{border: "1px solid #1b7ea9", width: "59px"}}><span
                style={{fontSize: "14px", margin: ".5rem"}}>{props.value.toString().concat(" km")}</span></div>
            <input style={{width:"70%",marginLeft:"2%"}} id={props.id} type="range" className={style.slider}
                   min={"0"} max={"30"} value={props.value} onChange={props.onChange}/>

        </div>
    )


}

export default RangeSlider
